import React, { useCallback, useContext, useState } from 'react'
import { extractMessage, generate_guid } from '../utils'

export interface IGlobalError {
  guid: string
  status?: number
  message?: string
}

export const fromAxiosError = (err: any) => {
  if (err) {
    return {
      guid: generate_guid(),
      message: extractMessage(err),
      status: err?.response?.status,
    }
  } else {
    return undefined
  }
}

interface ContextProps {
  errors: IGlobalError[]
  addError: (message: string, status: number) => void
  removeError: (guid: string) => void
}

const Context = React.createContext<ContextProps>({
  errors: [],
  addError: () => {},
  removeError: () => {},
})

export const useGlobalError = () => {
  const { errors, addError, removeError } = useContext(Context)
  return { errors, addError, removeError }
}

interface GlobalErrorProps {
  children: any
}

export const GlobalError: React.FC<GlobalErrorProps> = ({ children }) => {
  const [errors, setErrors] = useState<IGlobalError[]>([])

  const removeError = (guid: string) => {
    setErrors(prevState => prevState.filter(e => e.guid !== guid))
  }

  const addError = (message: string, status: number) =>
    setErrors(prevState => [...prevState, { message, status, guid: generate_guid() }])

  const contextValue = {
    errors,
    addError: useCallback((message: any, status: any) => addError(message, status), []),
    removeError: useCallback(removeError, []),
  }

  return <Context.Provider value={contextValue}>{children}</Context.Provider>
}
